(() => {
  if (window.azikxSizeChartMobileLoaded) return;
  window.azikxSizeChartMobileLoaded = true;

  const labelElement = document.getElementById('azikx-size-chart-labels');
  if (!labelElement) return;
  const labels = JSON.parse(labelElement.textContent);
  const selector = [
    'div[class^="size-chart-bella-table-wrap-"]',
    'div[class^="size-chart-gildan-table-wrap-"]',
    'div[class^="azikx-kids-chart__table-wrap-"]'
  ].join(',');
  const mobile = matchMedia('(max-width: 749px)');
  const states = new Map();
  let count = 0;

  const sync = (state) => {
    state.range.value = String(state.wrapper.scrollLeft);
  };

  const update = (state) => {
    const width = state.wrapper.clientWidth;
    const max = Math.max(0, state.wrapper.scrollWidth - width);
    const active = mobile.matches && width > 0 && max > 1;
    state.tools.hidden = !active;
    state.wrapper.dataset.overflow = String(active);
    state.range.max = String(max);
    state.range.style.setProperty('--azikx-scroll-thumb-size', `${Math.max(28, width * width / Math.max(1, state.wrapper.scrollWidth))}px`);
    if (active) {
      state.wrapper.setAttribute('tabindex', '0');
      state.wrapper.setAttribute('role', 'region');
      state.wrapper.setAttribute('aria-label', labels.region);
      state.wrapper.setAttribute('aria-describedby', state.hint.id);
    } else {
      ['tabindex', 'role', 'aria-label', 'aria-describedby'].forEach((name) => state.wrapper.removeAttribute(name));
    }
    sync(state);
  };

  const observer = new ResizeObserver((entries) => {
    const changed = new Set();
    entries.forEach(({ target }) => {
      const state = states.get(target) || states.get(target.parentElement);
      if (state) changed.add(state);
    });
    changed.forEach(update);
  });

  const init = (root) => {
    root.querySelectorAll(selector).forEach((wrapper) => {
      if (states.has(wrapper)) return;
      const table = wrapper.querySelector('table');
      if (!table) return;
      const id = ++count;
      wrapper.id ||= `azikx-size-scroll-${id}`;
      wrapper.classList.add('azikx-size-scroll');
      let surface = wrapper;
      while (surface) {
        const background = getComputedStyle(surface).backgroundColor;
        if (background !== 'rgba(0, 0, 0, 0)' && background !== 'transparent') {
          wrapper.style.setProperty('--azikx-size-surface', background);
          break;
        }
        surface = surface.parentElement;
      }
      const tools = document.createElement('div');
      tools.className = 'azikx-size-scroll-tools';
      tools.hidden = true;
      const range = document.createElement('input');
      range.type = 'range';
      range.className = 'azikx-size-scroll-range';
      range.min = '0';
      range.step = '1';
      range.value = '0';
      range.setAttribute('aria-label', labels.label);
      range.setAttribute('aria-controls', wrapper.id);
      const hint = document.createElement('p');
      hint.id = `azikx-size-scroll-hint-${id}`;
      hint.textContent = labels.hint;
      tools.append(range, hint);
      wrapper.after(tools);
      const state = { wrapper, table, tools, range, hint };
      states.set(wrapper, state);
      range.addEventListener('input', () => { wrapper.scrollLeft = Number(range.value); });
      wrapper.addEventListener('scroll', () => sync(state), { passive: true });
      observer.observe(wrapper);
      observer.observe(table);
      update(state);
    });
  };

  mobile.addEventListener('change', () => states.forEach(update));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    states.forEach((state, wrapper) => {
      if (!event.target.contains(wrapper)) return;
      observer.unobserve(wrapper);
      observer.unobserve(state.table);
      state.tools.remove();
      states.delete(wrapper);
    });
  });
  init(document);
})();
